import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import AppButton from '../../../components/designe/buttons/app-button/AppButton';
import AppDialog from '../../../components/reusable/app-dialog/AppDialog';
import { useStyles } from './CompleteRegistration.styles';

interface IRegistrationSkipSettingsDialogProps {
  open: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
}

export default function RegistrationSkipSettingsDialog({
  open,
  title,
  message,
  onConfirm,
}: IRegistrationSkipSettingsDialogProps) {
  const { t } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles(theme);

  return (
    <AppDialog
      open={open}
      onClose={() => undefined}
      title={title}
      hideCloseButton
      disableDismiss>
      <Box className={classes.skipInfoContent}>{message}</Box>
      <AppButton
        fullWidth
        variant="contained"
        color="primary"
        onClick={onConfirm}>
        {t('common.confirm')}
      </AppButton>
    </AppDialog>
  );
}
